/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createPayment} from '../api'

export const useMutationCreatePayment = createReactQueryMutationHook('createPayment', createPayment)
